export const isHOGDomain = () => {
    const url = new URL(window.location.href)
    return url?.hostname?.includes('hogasia')
}
